import React from "react";
import { Select } from "antd";
import countryList from "react-select-country-list";
import ReactCountryFlag from "react-country-flag";

const blackListCountries = [
  'AF', 'DZ', 'AO', 'BS', 'BY', 'BJ', 'BW', 'BF', 'BI', 'CM', 'CF', 'TD',
  'CO', 'KM', 'CD', 'CG', 'CU', 'DJ', 'DM', 'DO'
]

export default class CountrySelector extends React.Component {
  render() {
    // const { blackListCountries } = this.props;
    // let countries = countryList().getData();
    // if (blackListCountries && blackListCountries.length > 0) {
    //     countries = countries.filter(country => !blackListCountries.includes(country.value))
    // }
    const countries = countryList().getData() //.filter(country => !blackListCountries.includes(country.value))
    return (
      <Select
        size={this.props.size}
        showSearch
        placeholder={this.props.placeholder}
        optionFilterProp="children"
        onChange={this.props.onChange}
        value={this.props.value}
      >
        {countries.map((country, idx) => {
          return (
            <Select.Option value={country.value} key={country.value} disabled={blackListCountries.includes(country.value)}>
              <ReactCountryFlag code={country.value} />
              {country.label}
            </Select.Option>
          );
        })}
      </Select>
    );
  }
}
